import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Table,
  Button,
} from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { SearchOutlined } from "@ant-design/icons";
import { pesquisarPessoasJuridicas } from "../../../services/apiCad";

import { maskCnpj } from "../../../utils/maskFunctions";

import { apiCand } from "../../../services/apiCand";

import { AlignType } from 'rc-table/lib/interface';
import { useNavigate } from "react-router-dom";
import { errorMessage, infoMessage } from "../../../utils/messages";

import "../style.css";

import { useLocation } from "react-router";
import { hasText, isStateValid, onlyNumbers } from "../../../utils/utilsFunctions";
import { IPessoaJuridica } from "../../../Interfaces/DadosPrevicInterfaces";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../parametrosUI";


interface ICertificadora {
  pessoaJuridica: IPessoaJuridica;
  idCertificadora: number;
  cnpj: string;
  dtCancelamento?: string;
  nuProcesso?: string;
}

const Consultar: React.FC<any> = (props: any) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [form] = Form.useForm();

  const [pessoaJuridicas, setPessoaJuridicas] = useState<IPessoaJuridica[]>([]);
  const [certificadora, setCertificadoras] = useState<ICertificadora[]>([]);

  const cnpj = form.getFieldValue("cnpj");

  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  const [estadoPag, setEstadoPag] = useState({
    fluxoPagina: 0,
    query: "",
    valores: {
      linhaPorPagina: DEFAULT_PAGE_SIZE,
      cnpj: "",
      pagina: 1,
      razaoSocial: "",
    },
  });


  useEffect(() => {
    window.scrollTo(0, 0)

    setLoading(true);
    if (isStateValid(state)) {
      setEstadoPag(state);

      form.setFieldsValue({
        cnpj: state.valores.cnpj,
        razaoSocial: state.valores.razaoSocial,
        linhaPorPagina: state.valores.linhaPorPagina,
        pagina: state.valores.pagina,
      });

      //getPessoaJuridica(state.query);
    } else {
      form.setFieldsValue({
        cnpj: "",
        razaoSocial: "",
        linhaPorPagina: DEFAULT_PAGE_SIZE,
        pagina: 1,
      });
    }
    setLoading(false);
  }, []);

  const [dadosPJ, setDadosPJ] = useState({
    razaoSocial: "",
    cnpj: "",
  });

  function pushToCadastro(razaoSocial: string, cnpj: string) {
    verificaSeECertificadora(razaoSocial, cnpj);
  }

  useEffect(() => {
    if (hasText(dadosPJ.cnpj)) navigate("/certificadoras/cadastrar", { state: dadosPJ });
  }, [dadosPJ]);

  useEffect(() => {
    let isCertificadoraAtiva = false;
    let isCertificadora = false;
    let razaoSocial = "";
    let nuCnpj = "";

    if (certificadora.length > 0) {
      for (const content of certificadora) {
        razaoSocial = content.pessoaJuridica.razaoSocial;
        nuCnpj = content.cnpj;

        if (content.idCertificadora === 0) {
          isCertificadora = false;
        } else if (content.dtCancelamento === undefined || content.dtCancelamento === "") {
          isCertificadora = true;
          isCertificadoraAtiva = true;
        } else {
          isCertificadora = true;
        }
      }

      if (isCertificadora && isCertificadoraAtiva) {
        errorMessage("Pessoa jurídica de CNPJ " + maskCnpj(nuCnpj) + " já consta como certificadora ativa");
      } else if (isCertificadora) {
        infoMessage("Atenção. Pessoa jurídica de CNPJ " + maskCnpj(nuCnpj) + " já consta como certificadora");
      }

      if (!isCertificadoraAtiva) {
        setDadosPJ({
          razaoSocial: razaoSocial,
          cnpj: nuCnpj,
        });
      }
    }
  }, [certificadora]);

  const verificaSeECertificadora = async (razaoSocial: string, nuCnpj: string) => {
    try {
      setLoading(true);

      const cnpj = onlyNumbers(nuCnpj) || "";

      let lQuery = `certificadoras?cnpj=${cnpj}`;

      const { data } = await apiCand.get(lQuery);

      if (!data.empty) {
        setCertificadoras(data.content);
      } else {
        setCertificadoras([{
          pessoaJuridica: {razaoSocial: razaoSocial, cnpj: nuCnpj },
          idCertificadora: 0, // AINDA NÃO É CERTIFICADORA
          cnpj: nuCnpj
        }]);
      }

    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  }

  function gerarColunas() {
    let cols: any[] = [];

    cols.push({
      width: 180,
      title: "CNPJ",
      dataIndex: "",
      render: (pj: IPessoaJuridica) => (
        <Input
          value={maskCnpj(pj.cnpj)}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push({
      width: 400,
      title: "Razão Social",
      dataIndex: "razaoSocial",
    });

    cols.push({
      width: 100,
      title: "Selecionar",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (pj: IPessoaJuridica) => (
        <Button
          shape="round"
          id='detalhar'
          icon={<SearchOutlined />}
          htmlType="button"
          onClick={() =>
            pushToCadastro(pj.razaoSocial, pj.cnpj)
          }
        />
      ),
    });

    return cols;
  }

  const columns = gerarColunas();

  const cnpjNaoEncontrado = () => {
    infoMessage("O sistema não encontrou resultado para consulta realizada");
  };

  const getPessoaJuridica = async () => {
    try {
      setLoading(true);

      const cnpj = onlyNumbers(form.getFieldValue("cnpj")) || "";
      const razaoSocial = form.getFieldValue("razaoSocial") || "";
      const linhaPorPagina = form.getFieldValue("linhaPorPagina") || DEFAULT_PAGE_SIZE;

      let lQuery = `pessoasJuridicas?limit=${linhaPorPagina}&cnpj=${cnpj}&page=0&razao-social=${razaoSocial}`;

      const data = await pesquisarPessoasJuridicas(cnpj, razaoSocial, linhaPorPagina, undefined);

      setPessoaJuridicas(data);
      setTotalElements(data.length);
      gerarJsonState(lQuery);

      if (data.length === 0) {
        cnpjNaoEncontrado();
      }
    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  };

  const [pageSize, setpageSize] = useState<number>(DEFAULT_PAGE_SIZE);

  const handlePaginationChange = async (page: number, pagination?: number) => {
    if (pagination) {
      setpageSize(pagination);
    }
    form.setFieldsValue({
      pagina: page,
    });
    getPessoaJuridica();
  };

  const handleShowSizeChange = async (current: any, size: any) => {
    form.setFieldsValue({
      linhaPorPagina: size,
    });
    getPessoaJuridica();
  };

  function gerarJsonState(lQuery: any) {
    setEstadoPag({
      fluxoPagina: 0,
      query: lQuery,
      valores: {
        linhaPorPagina: form.getFieldValue("linhaPorPagina") || DEFAULT_PAGE_SIZE,
        cnpj: onlyNumbers(form.getFieldValue("cnpj")) || "",
        pagina: form.getFieldValue("pagina") || 0,
        razaoSocial: form.getFieldValue("razaoSocial") || "",
      },
    });
  }

  function limparConsulta() {
    setPessoaJuridicas([]);
    setCertificadoras([]);
    setTotalElements(0);
    form.resetFields();
  }

  const maskFieldCnpj = (isValue: string) => {
    if (form.getFieldValue("cnpj")) {
      isValue = form.getFieldValue("cnpj");
    }
    form?.setFieldsValue({
      cnpj: maskCnpj(isValue),
    });
    // console.log(form.getFieldValue("cnpj"))
  };

  useEffect(() => {
    maskFieldCnpj(cnpj);
  }, [cnpj]);



  return (
    <>
      <PageHeader
        className="site-page-header"
        title="Cadastro de Certificadoras - Consultar Pessoa Jurídica"
        style={{
          marginTop: "-18px",
          background: "#2160BD",
          padding: 5,
          paddingLeft: 24,
        }}
      />

      <Card variant="borderless" style={{ width: "100%" }}>
        <Form layout="vertical" form={form} style={{ marginTop: "-100px" }}>
          <Form.Item name="pagina" />
          <Form.Item name="linhaPorPagina" />

          <Row>
            <Col xs={24} sm={5}>
              <Form.Item label="CNPJ" name="cnpj">
                <Input
                  value={form.getFieldValue("cnpj")}
                  onChange={(e) => maskFieldCnpj(e.target.value)}
                  placeholder="Digitar CNPJ"
                  maxLength={18}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item label="Razão Social" name="razaoSocial">
                <Input placeholder="Digitar razão social" />
              </Form.Item>
            </Col>
          </Row>

          <Row justify="center">
            <>
              <Button
                style={{ marginRight: "5px" }}
                id="consultar"
                type="primary"
                value="default"
                shape="round"
                onClick={() => getPessoaJuridica()}
              >
                Consultar
              </Button>
              <Button
                id="limpar"
                value="default"
                shape="round"
                onClick={() => limparConsulta()}
              >
                Limpar
              </Button>
            </>
          </Row>
        </Form>
      </Card>

      <Card title={"Resultado da consulta - " + totalElements + " encontrados"} style={{ display: totalElements === 0 ? 'none' : 'inline' }}>
        <Table
          // className="overflowConsulta"
          dataSource={pessoaJuridicas}
          columns={columns}
          rowKey="id"
          loading={loading}
          pagination={{
            // disabled: loading,
            // current: form.getFieldValue("pagina"),
            defaultPageSize: DEFAULT_PAGE_SIZE,
            pageSize: pageSize,
            total: totalElements,
            showSizeChanger: true,
            onShowSizeChange: handleShowSizeChange,
            onChange: handlePaginationChange,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            locale: { items_per_page: "Linhas por página" },
          }}
        />
      </Card>
    </>
  );
};

export default Consultar;
